export const spaceName = 'odSettingPersonal';

export interface PersonalSettings {
  personalData: any;

  showProcessingInfo: {
    show: boolean;
    time: number;
  };
}

export default {
  showProcessingInfo: {
    show: false,
  },
} as PersonalSettings;
